import {formatISO, isValid, getTime, getDay, differenceInMinutes, format} from 'date-fns'
import {formatInTimeZone} from 'date-fns-tz'
import {uk, enGB} from 'date-fns/locale'
import getStorageLanguage from 'utils/getLang'

type DateInput = string | number | Date
type LanguageCode = 'uk' | 'en'
type LocaleType = typeof uk

const locales: Record<LanguageCode, LocaleType> = {uk, en: enGB}

export const FULL_DATE_TIME = 'dd.MM.yyyy HH:mm'
export const MONTH = 'LLLL'
export const MONTH_SHORT_NAME = 'MMM'
export const FULL_DATE = 'dd.MM.yyyy'
export const FULL_TIME = 'HH:mm'
export const YEAR = 'yyyy'
export const TIME = 'HH:mm'

export const dateFormatISO = (date: DateInput): string =>
  isValid(new Date(date)) ? formatISO(new Date(date)) : ''

const KYIV_TZ = 'Europe/Kiev'

export const setDateFormat = (date: DateInput, f?: string): string =>
  isValid(new Date(date))
    ? formatInTimeZone(new Date(date), KYIV_TZ, f || FULL_DATE_TIME, {
        locale: locales[getStorageLanguage() as LanguageCode],
      })
    : ''

export const getTimeFromDate = (date: DateInput): number | string =>
  isValid(new Date(date)) ? getTime(new Date(date)) : ''

export const getDayOfTheWeek = (date: DateInput): number | string =>
  isValid(new Date(date)) ? getDay(new Date(date)) : ''

export const getMonthName = (monthNumber: number): string =>
  format(new Date(2000, monthNumber, 1), MONTH_SHORT_NAME, {
    locale: locales[getStorageLanguage() as LanguageCode],
  })

export const getDifferenceInMinutes = (
  firstDate: DateInput,
  secondDate: DateInput,
): number | string =>
  isValid(new Date(firstDate)) && isValid(new Date(secondDate))
    ? differenceInMinutes(new Date(firstDate), new Date(secondDate))
    : ''

export const getWithoutTimeZone = (date: Date): Date | string =>
  isValid(date) ? new Date(date.getTime() - date.getTimezoneOffset() * 60000) : ''
